import { Routes, Route, Navigate } from 'react-router-dom';
import { Footer, Header, Main, TextSubtle } from './components/CommonComponents';
import { LoginPage } from './pages/user/Login';
import { AuthProvider, useAuthContext } from './context/AuthProvider';
import { CreateAccountPage } from './pages/user/CreateAccount';
import { UserManagement } from './pages/user/UserManagement';
import { Flexbox } from './components/Flexbox';
import { Navigation } from './components/Navigation';
import { Homepage } from './pages/homepage/Homepage';
import { ColourPalettesPage } from './pages/colour-palettes/ColourPalettesPage';
import { ColoursPage } from './pages/colours/ColoursPage';
import { CssBaseline } from '@mui/material';
import { ColourPalettePage } from './pages/colour-palette/ColourPalettePage';
import { UserSettings } from 'pages/user/settings/UserSettings';
import { ColourSettingProvider } from 'context/ColourSettingProvider';

const ProtectedRoute = ({ children }) => {
    const [isAuthenticated] = useAuthContext();
    return isAuthenticated ? children : <Navigate replace to="/login" />;
};

const AuthCheckForPublicPage = ({ children }) => {
    const [isAuthenticated] = useAuthContext();
    return isAuthenticated ? <Navigate replace to="/" /> : children;
};

function App() {
    return (
        <AuthProvider>
            <ColourSettingProvider>
                <CssBaseline />
                <div className="app grid gap-3">
                    <Header>
                        <Flexbox marginTop={12} placeContent="space-between">
                            <Navigation />
                            <UserManagement />
                        </Flexbox>
                    </Header>

                    <Main>
                        <Routes>
                            <Route path="/" element={<Homepage />}></Route>
                            <Route
                                path="/colour-palettes"
                                element={
                                    <ProtectedRoute>
                                        <ColourPalettesPage />
                                    </ProtectedRoute>
                                }
                            ></Route>
                            <Route
                                path="/colours"
                                element={
                                    <ProtectedRoute>
                                        <ColoursPage />
                                    </ProtectedRoute>
                                }
                            ></Route>
                            <Route
                                path="/colour-palettes/:id"
                                element={
                                    <ProtectedRoute>
                                        <ColourPalettePage />
                                    </ProtectedRoute>
                                }
                            ></Route>
                            <Route
                                path="/login"
                                element={
                                    <AuthCheckForPublicPage>
                                        <LoginPage />
                                    </AuthCheckForPublicPage>
                                }
                            ></Route>
                            <Route
                                path="/create-account"
                                element={
                                    <AuthCheckForPublicPage>
                                        <CreateAccountPage />
                                    </AuthCheckForPublicPage>
                                }
                            ></Route>
                            <Route
                                path="/settings"
                                element={
                                    <ProtectedRoute>
                                        <UserSettings />
                                    </ProtectedRoute>
                                }
                            />
                        </Routes>
                    </Main>

                    <Footer>
                        <TextSubtle>Copyright 2022</TextSubtle>
                    </Footer>
                </div>
            </ColourSettingProvider>
        </AuthProvider>
    );
}

export default App;
